/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue } from '../../app.vues';
import { Utils } from '../../app.base'

import SwbStockListForSelect from './StockListForSelect';
Vue.regist(SwbStockListForSelect);
//

// 共享配件选择 - 工单使用
export function showShareAccSelect(checkedIds, comId, warehouseId, callback, isSelect, isDisabled) {
    isDisabled = Utils.isTrue(isDisabled);
    Vue.$showDialog({
        title: "配件选择",
        width: 1100,
        height: 750,
        showCloseBtn: true,
        okVisible: true,
        cancelText: "取消",
        template: '<swb-share-acc-stock-list-for-select :checkedIds="checkedIds" :comId="comId" :warehouseId="warehouseId" :isSelect="isSelect" :isDisabled="isDisabled" ref="swb_share_acc_stock_list_for_select"></swb-share-acc-stock-list-for-select>',
        data: {
            checkedIds: checkedIds,
            comId: comId,
            warehouseId: warehouseId,
            isSelect: isSelect,
            isDisabled: isDisabled
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_share_acc_stock_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                //
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {}
    });
}

// ================================== 共享配件调配申请单 ==================================
import SwbAdjustApplyFormInfo from './AdjustApplyFormInfo';
Vue.regist(SwbAdjustApplyFormInfo);

// 查看详情
export function openShareAccAdjustApplyFormInfo(formId) {
    Vue.$showDialog({
        title: "详情",
        width: 1100,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-adjust-apply-form-info :formId="formId" ref="swb_adjust_apply_form_info"></swb-adjust-apply-form-info>',
        data: {
            formId: formId
        },
        methods: {},
        okClicked: function () {
        },
        lifecycle: {}
    });
}

import SwbAdjustApplyFormSave from './AdjustApplyFormSave';
Vue.regist(SwbAdjustApplyFormSave);

// 新增
export function saveShareAccAdjustFormDlg(formId, thisComId, callback) {
    Vue.$showDialog({
        title: "共享配件调配单-新增",
        width: -600,
        height: 750,
        showCloseBtn: true,
        template: '<swb-adjust-apply-form-save :thisComId="thisComId" :formId="formId" ref="swb_adjust_apply_form_save"></swb-adjust-apply-form-save>',
        data: {
            thisComId: thisComId,
            formId: formId
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_adjust_apply_form_save.getDlgResult() || {};
            if(result.type === 'info') {
                //
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAdjustApplyFormFileUpload from './AdjustApplyFormFileUpload';
Vue.regist(SwbAdjustApplyFormFileUpload);

// 配件调配上传附件信息
export function openAdjustApplyFormFileUploadDlg(params, callback) {
    let voucherId = params.voucherId || null;
    let auditAttrFlag = params.auditAttrFlag || null;
    let selectFileList = params.selectFileList || [];
    Vue.$showDialog({
        title: '配件附件上传',
        width: 1000,
        height: 800,
        template: '<swb-share-acc-adjust-apply-form-file-upload :voucherId = "voucherId" :auditAttrFlag="auditAttrFlag" :selectFileList="selectFileList" ref="swb_share_acc_adjust_apply_form_file_upload"></swb-share-acc-adjust-apply-form-file-upload>',
        data: {
            voucherId: voucherId,
            auditAttrFlag: auditAttrFlag,
            selectFileList: selectFileList
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_share_acc_adjust_apply_form_file_upload.getDlgResult() || {};
            //
            if(result.type === 'info') {
                //
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAdjustApplyFormFile from './AdjustApplyFormFile';
Vue.regist(SwbAdjustApplyFormFile);

// 配件调配查看附件信息
export function openAdjustApplyFormFileInfoDlg(params) {
    let voucherId = params.voucherId || null;
    Vue.$showDialog({
        title: '查看附件',
        width: 1000,
        height: 800,
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-share-acc-adjust-apply-form-file :voucherId = "voucherId" ref="swb_share_acc_adjust_apply_form_file"></swb-share-acc-adjust-apply-form-file>',
        data: {
            voucherId: voucherId,
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_share_acc_adjust_apply_form_file.getDlgResult() || {};
            //
        }
    });
}
import SwbStockQuantityChange from './StockQuantityChange';
Vue.regist(SwbStockQuantityChange);
// 设备租赁详情
export function openSwbStockQuantityChangeDlg(dlgConfig, callback) {
    let row = dlgConfig['row'] || null;
    let title = dlgConfig["title"] != null ? dlgConfig['title'] : '数量转换';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<swb-stock-quantity-change :row="row" ref="swb_stock_quantity_change"></swb-stock-quantity-change>',
        data: {
            row: row
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_stock_quantity_change.getDlgResult() || {};
            if(result.type == "info") {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbMerchtAccDefSelect from './MerchtAccDefSelect';
Vue.regist(SwbMerchtAccDefSelect);

//选择配件定义objectId 商户id，checkedIds回显禁用ids 服务商系统上，申领用
export function openMerchtAccDefListSelectDlg(objectId, checkedIds, callback) {
    Vue.$showDialog({
        title: '选择配件列表',
        width: -400,
        height: 800,
        showCloseBtn: true,
        template: '<swb-mercht-acc-def-list-select :objectId = "objectId" :checkedIds = "checkedIds" ref="swb_mercht_acc_def_list_select"></swb-mercht-acc-def-list-select>',
        data: {
            objectId: null,
            checkedIds: []
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_mercht_acc_def_list_select.getDlgResult() || {};
            if(result.type === 'info') {
                let accDefList = result.data;
                callback(accDefList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.objectId = objectId || null;
                this.checkedIds = checkedIds || [];
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/shareAcc/selectDlg.js
// module id = 252
// module chunks = 0